import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { getLineItemAnswer, postLineItemAnswer } from '../storeDashboard.thunks';
import { triggerCustomUxCriticalError } from '../../../actions/error';
import './styles.scss';

const QuestionForm = ({ part, handleClose, handleApproveItem }) => {
  const dispatch = useDispatch();
  const { questionsData, answersData } = useSelector(state => state.storeDashBoard);
  const [questions, setQuestions] = useState([]);
  const [criteriaMatched, setCriteriaMatched] = useState(null);


  // Handle fetched questions data
  useEffect(() => {
    if (!_isEmpty(questionsData)) {
      const currentQuestions = questionsData
        .filter(q => q.returnType === part.returnType)
        .map(q => q.restrictionText);
      if (currentQuestions.length > 0) {
        setQuestions(currentQuestions);
      }
    }
  }, [questionsData]);

  // Handle fetched answers data
  useEffect(() => {
    if (!_isEmpty(answersData)) {
      const returnTypeAnswer = answersData.returnTypeAnswers?.[0];
      const answerValue = !returnTypeAnswer || returnTypeAnswer.ans === null
        ? 'No'
        : returnTypeAnswer.ans ? 'Yes' : 'No';
      setCriteriaMatched(answerValue);
    }
  }, [answersData]);

  // Load questions based on part's return type
  useEffect(() => {
    if (!_isEmpty(part)) {
      let payload = {
        partReturnLineId: part?.id,
        returnType: part?.returnType?.toString() || ''
      }
      dispatch(getLineItemAnswer(payload));
    }
  }, [part.returnType, dispatch]);

  const handleChange = (value) => {
    setCriteriaMatched(value);
  };

  const handleSubmit = async () => {

    const payload = {
      returnItemId: part?.id,
      returnTypeAnswers: [
        {
          returnType: part?.returnType,
          ans: criteriaMatched === 'Yes' ? true : false
        }
      ]
    }

    try {
      await dispatch(postLineItemAnswer(payload));
      triggerCustomUxCriticalError({
        heading: 'Criteria Submitted Successfully',
        message: '',
        type: 'success',
      }, dispatch);
      if (criteriaMatched === 'Yes') {
        handleApproveItem(
          part.APPROVED,
          part,
          part.headerLineItems,
          part.lineIndex
        );
      }
      handleClose();
    } catch (error) {
      console.error('Error submitting answers:', error);
    }
  };

  return (
    <div className="question-form-container">
      <div className="question-form">
        <ul className="light-maroon-bullets">
          {questions.map((question, index) => (
            <li key={index} className="question-text">
              {question}
            </li>
          ))}
        </ul>
        <div className="criteria-question">
          <p>Does the return follow this criteria?</p>
          <div className="answer-options">
            {['Yes', 'No'].map(value => (
              <label key={value} className="answer-label radio-button-questionform">
                <input
                  type="radio"
                  name="criteriaMatched"
                  value={value}
                  checked={criteriaMatched === value}
                  onChange={() => handleChange(value)}
                  className="answer-input"
                />
                <span>{value}</span>
              </label>
            ))}
          </div>
        </div>
        <div className="return-submit-btn">
          <Button onClick={handleSubmit}>Submit</Button>
        </div>
      </div>
    </div>
  );
};

export default QuestionForm;
